// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "h3[data-v-f5187e6a]{margin:40px 0 0}ul[data-v-f5187e6a]{list-style-type:none;padding:0}li[data-v-f5187e6a]{display:inline-block;margin:0 10px}a[data-v-f5187e6a]{color:#42b983}", ""]);
// Exports
module.exports = exports;
